<template>
    <div>
        <div class="py-3" style="">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1 class="d-flex justify-content-center">Receipt Bucket</h1>

                        <div style="text-align:center;">
                            <ul style="text-align:center;">
                                <li v-for="file in files" :key="file.id">
                                    <span v-if="file.error">Error uploading file: {{file.name}} Error: {{file.error}}</span>
                                </li>
                            </ul>
                            <div class="example-simple">
                                <div class="upload">
                                    <div class="upload-button">
                                        <file-upload class="btn btn-primary upload-button"
                                                     :post-action="this.receiptURL"
                                                     extensions="gif,jpg,jpeg,png,webp,pdf,doc,docx,csv,xlsx"
                                                     accept="image/png,image/gif,image/jpeg,image/webp,application/pdf,image/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                                     :multiple="true"
                                                     :headers="{'Authorization': 'Bearer ' + this.msal.accessToken}"
                                                     v-model="files"
                                                     input-id="file1"
                                                     @input-filter="inputFilter"
                                                     @input-file="inputFile"
                                                     :drop="true"
                                                     ref="upload">
                                            <i class="fa fa-plus"></i>
                                            Select files
                                        </file-upload>
                                        <button type="button" class="btn btn-success upload-button" style="display:none;" v-if="!$refs.upload || !$refs.upload.active" @click.prevent="$refs.upload.active = true">
                                            <i class="fa fa-arrow-up" aria-hidden="true"></i>
                                            Start Upload
                                        </button>
                                        <button type="button" class="btn btn-danger upload-button" v-else @click.prevent="$refs.upload.active = false">
                                            <i class="fa fa-stop" aria-hidden="true"></i>
                                            Stop Upload
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="py-3">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div style="text-align:center; padding-bottom:20px; ">
                            <b-form-group size="sm">
                                <b-form-radio-group id="btn-radios-1"
                                                    v-model="toggleSelectedValue"
                                                    :options="optionsLink"
                                                    buttons
                                                    name="radios-btn-default">
                                </b-form-radio-group>
                            </b-form-group>
                        </div>
                        <div class="thumbnail-container">
                            <!-- Do google doc stuff here -->
                            <div v-if="(toggleSelectedValue == 'Unlinked' && r.expenseReportId == null) || (toggleSelectedValue == 'Linked' == true && r.expenseReportId != null)" v-for="r in rowData" class="card-styling">
                                <div>
                                    <div style="min-height:150px; max-height:150px;" class="img-center-vertically">
                                        <img class="img" v-bind:src="r.thumbnailUrl" @click="downloadFileInNewWindow(r)" referrerpolicy="no-referrer"/>
                                    </div>
                                    <div class="card-description">
                                        <div class="row">
                                            <div class="col-md-12 d-flex justify-content-center" style="padding-top: 5px;">
                                                <font-awesome-icon class="icons" style="margin-right: 15px;" icon="edit" @click="editFileName(r)" />
                                                <font-awesome-icon v-if="r.expenseReportId == null" class="icons" icon="trash" @click="deleteReceipt(r)" />
                                            </div>
                                        </div>

                                        <a v-if="r.expenseReportId != null" v-bind:href="(r.isExpenseReportMisc ? 'misc-expense-report/' : 'review-submit/') + r.expenseReportId" style="font-weight: 500;">Expense Report</a>
                                        <div class="receipt-name" v-bind:title="r.receiptName">
                                            {{r.receiptName}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal -->

        <div>
            <b-modal id="modal-1" title="File Name" @ok="renameReceipt(receiptSelected)">
                <b-form-input v-model="receiptSelected.receiptName" placeholder="file name"></b-form-input>
                <div>
                    Created: {{receiptSelected._displayDate}}
                </div>
            </b-modal>
        </div>
    </div>
</template>
<style scoped>
    ul {
        list-style: none;
    }

    .upload-button {
        margin-top: 10px;
    }

    .thumbnail-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .example-simple label.btn {
        margin-bottom: 0;
        margin-right: 1rem;
    }

    input:disabled {
        background: none;
    }

    .card-styling {
        border: 1px solid #151616;
        border-radius: 3px;
        margin-bottom: 20px;
        margin-right: 20px;
    }

        .card-styling:hover {
            border: 2px solid #12bbad;
            margin-bottom: 17px;
            margin-right: 17px;
        }

    .icons {
        color: grey;
        cursor: pointer;
        font-size: 1.25em;
    }

        .icons:hover {
            color: #12bbad;
        }

    svg:hover {
        fill: red;
    }

    .card-description {
        border-top: 1px solid #d0d2d7;
        height: 95px;
        max-width: 125px;
        text-align: center;
    }

    .img-center-vertically {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .img {
        width: 125px;
        max-height: 150px;
        cursor: pointer;
    }

    .receipt-name {
        max-height: 3.3em;
        overflow: hidden;
        font-weight: 500;
        font-size: smaller;
    }
</style>
<script>
    import FileUpload from 'vue-upload-component'

    export default {
        name: "receipt-bucket",
        components: {
            FileUpload
        },
        data() {
            return {
                files: [],
                receiptURL: this.$hostname + 'receipts',
                receipts: [],
                columnDefs: null,
                gridOptions: null,
                rowData: [],
                show_modal: false,
                receiptSelected: {},
                toggleSelectedValue: "Unlinked",
                optionsLink: [
                    { text: 'Unlinked', value: 'Unlinked' },
                    { text: 'Linked', value: 'Linked' }
                ],
            }
        },
        async beforeMount() {
            await this.getReceipts();
        },
        methods: {



            //sanitize input filter for upload client side
            inputFilter(newFile, oldFile, prevent) {
                if (newFile && !oldFile) {
                    // Before adding a file
                    // Filter system files or hide files
                    if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
                        return prevent()
                    }
                    // Filter php html js file
                    if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
                        return prevent()
                    }
                }
            },

            //event triggers on upload
            inputFile(newFile, oldFile) {
                if (newFile && oldFile) {
                    if (newFile && !oldFile) {
                        // add
                    }
                    if (newFile && oldFile) {
                        // update
                    }
                    if (!newFile && oldFile) {
                        // remove
                    }
                    // Uploaded successfully
                    if (newFile.success !== oldFile.success) {
                        this.getReceipts();
                    }
                }

                // Automatically activate upload
                if (newFile !== oldFile || oldFile.error !== newFile.error) {

                    if (!this.$refs.upload.active) {
                        this.$refs.upload.active = true
                    }
                }

            },

            //Delete Receipt method
            deleteReceipt(receipt) {
                let deleteURL = 'receipts/' + receipt.id;
                if (confirm('Are you sure you want to delete this receipt?')) {
                    this.$http
                        .delete(deleteURL, {
                            headers: {
                                "Authorization": "Bearer " + this.msal.accessToken
                            }
                        })
                        .then(() => {
                            this.getReceipts();
                            this.$notify({
                                group: 'success',
                                type: 'success',
                                title: 'Success',
                                text: 'The receipt has been deleted'
                            });
                            this.errored = false;
                        })
                        .catch(error => {
                            this.$notify({
                                group: 'errors',
                                type: 'error',
                                title: 'Error',
                                text: error
                            });
                            this.errored = true
                        })
                        .finally(() => this.loading = false)
                }
            },

            //edit filename, makes copy of receipt selected and pops up modal
            editFileName(receipt) {
                let rec = receipt;
                this.receiptSelected = JSON.parse(JSON.stringify(rec));
                this.receiptSelected._displayDate = this.moment(this.receiptSelected.created).format('MM/DD/YYYY');
                this.$bvModal.show('modal-1')
            },

            //rename receipt
            renameReceipt(param) {
                var receipt = param;
                this.$http
                    .put('receipts', receipt, {
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then(() => {
                        this.getReceipts();
                        this.$notify({
                            group: 'success',
                            type: 'success',
                            title: 'Success',
                            text: 'Receipt Name Updated'
                        });
                        this.errored = false;
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: error
                        });
                        this.errored = true
                    })
                    .finally(() => this.loading = false)
            },

            //merge old array data into new array data (used to cache the thumbnails ajax call)
            mergeById(a1, a2) {
                return a1.map(itm => ({
                    ...a2.find((item) => (item.id === itm.id) && item),
                    ...itm
                }))
            },

            //get receipt
            getReceipts() {
                this.$http
                    .get('receipts', {
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then(response => {
                        let merged = this.mergeById(response.data, this.rowData);

                        merged.forEach((item) => {

                            //if thumbnail exists dont grab it again
                            if (!item.thumbnailUrl) {
                                item.thumbnailUrl = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAB3RJTUUH4woCATAGi1rqVwAAABh0RVh0U29mdHdhcmUAcGFpbnQubmV0IDQuMS42/U4J6AAABIJJREFUeF7tnU1r1FAYhftrBubHtdOBliSdxVTcVEHQhcuKGxdSBHUlogvBhZZCdSOuRezP0PN6r4u5k9pMPpq57zkPHILz8Sbn+gxRJk132nBwcPD0+Pj4t1KbJ8gkLpVPJMCN8S2BBGgUvxJIgMbxKUGdAGVZXu3t7b1lSlEU39N1qIk/CeoEsMfi0zSg9zJdh2viSwIJEEDvpgJY/EggAQLovYkAFh8SSIAAeq8JUFXVj/SxJPlLIAEC6L0mANbhAlv7S155PEneEkiAAHqvCWD/O8B2gviVQAIE0LtWgPicXwkkQAC9rxXAwJ99SiABAuj9XwEMPOZPAgkQQO8bBTDwuC8JJEAAvRsJYOA5PxJIgAB6NxbAwPM+JJAAAfTeSAADr8lfAgkQQO+NBTDwurwlkAAB9G4lgIHX5iuBBAigd2sBDLw+TwkkQAC9Owlg4D35SSABAujdWQAD78tLAgkQQO9eBDDw3nwkkAAB9O5NAAPvz0MCCRBA714FMDBj+yWQAAH07l0AA3O2WwIJEEDvQQQwMGt7JZAAAfQeTAAD87ZTgqEEsCLL5fIuZp3avJ5zarNtH3F3ncGsNQHsB2Rq9t06RVG8Pjo6+pzuJ8ntSmAHlhxAZwGsABbvPJ3bd7CPT9j2sliYsybAiFnGwxqegQS4zcXsZbFsTjJ3tGD9T+NhDY8ECNicZO5o6br+GzGQABOc724613WO11NA9gIYmDP0PwLv2D7i7jpjs2r2M3jwQfn2b93/xR6PhzU8trNRD4Cc0ddfAoyLBCBHApAjAciRAORIAHIkADkSgBwJQI4EIMetAJhjV8Asq6p6UJblQ0+xTtbNOsa6rXEpAGbYBSEf07neEjt2ksCrAFvz1eotpNP1CBIg/0iAFMywU8CXdK63FEVxia1OAXVgzmSxWNyfz+dnyAtnOUO3e9Yx1m2NWwFEMyQAORKAHAlAjgQgRwKQIwHIkQDkSAByJAA5EoActwJgzt8LQpxH3wXUgRmTqqrep3O9BR3fYatvA1Mwwz4dKzMdR9cDpGCGBGiIVwHsDiFNfh171ok3d9ApoA7MMQkez2azN3a/PU+xTmVZPrKOsW5r3AogmiEByJEA5EgAciQAORKAHAlAjgQgRwKQIwHIkQDkuBUAc6bIifNMY93WuBQAM6aLxeJDOtdbYsdOEngVwD4dKzMd5yTWboUEyD8SIAUzplVV/Urnegs6/sRWp4A6MGd6eHj4bH9//3w2m114inWybtYx1m2NWwFEMyQAORKAHAlAjgQgRwKQIwHIkQDkSAByJAA5EoActwJgju4Q0gCXAmCG3Sr+VTrXW9DxJbb68fAUzLBPx8pMx9ENIlIwQwI0xKsA9itj3F8Qgo52QYhOAXVgzmQ+nz/f3d29RL46y6V1s46xbmvcCiCaIQHIkQDkSAByJAA5EoAcCUCOBCBHApAjAciRAORIAHIkADkSgBwJQI4EIEcCkCMByJEA5EgAcrZSgLIsr+p+XZrSf2yt0/UfXQBl3EgA8kgA8kgA8rQTYGfnD9K0abxUqpkmAAAAAElFTkSuQmCC"
                            }
                        })

                        //update list with merged data
                        this.rowData = merged;

                        //order by id
                        this.rowData.sort(function (a, b) {
                            return b.id - a.id;
                        });
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: error
                        });
                        this.errored = true
                    })
                    .finally(() => this.loading = false)
            },
            //Downloads file as blob and pops up in new window
            downloadFileInNewWindow(params) {
                console.log(params)
                this.$http
                    .get('receipts/' + params.id + '/Download', {
                        responseType: 'blob',
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then((response) => {
                        const file = new Blob(
                            [response.data],
                            { type: response.headers['content-type'] });
                        const downloadUrl = window.URL.createObjectURL(file);
                        window.open(downloadUrl);
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: error
                        });
                        this.errored = true
                    })
                    .finally(() => this.loading = false)
            },

            //gets image thumbnail
            async getThumbnailBase64(id) {
                var thumbnailUrl = 'receipts/' + id + '/Download/Thumbnail'
                return await this.$http
                    .get(thumbnailUrl, {
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then((response) => {
                        var thumbNailb64 = 'data:' + response.data.mimeType + ';base64,' + response.data.file;

                        return thumbNailb64;
                    })
                    .catch(() => {
                        //handle case for when thumbnail doesnt exist
                        return "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAB3RJTUUH4woCATAGi1rqVwAAABh0RVh0U29mdHdhcmUAcGFpbnQubmV0IDQuMS42/U4J6AAABIJJREFUeF7tnU1r1FAYhftrBubHtdOBliSdxVTcVEHQhcuKGxdSBHUlogvBhZZCdSOuRezP0PN6r4u5k9pMPpq57zkPHILz8Sbn+gxRJk132nBwcPD0+Pj4t1KbJ8gkLpVPJMCN8S2BBGgUvxJIgMbxKUGdAGVZXu3t7b1lSlEU39N1qIk/CeoEsMfi0zSg9zJdh2viSwIJEEDvpgJY/EggAQLovYkAFh8SSIAAeq8JUFXVj/SxJPlLIAEC6L0mANbhAlv7S155PEneEkiAAHqvCWD/O8B2gviVQAIE0LtWgPicXwkkQAC9rxXAwJ99SiABAuj9XwEMPOZPAgkQQO8bBTDwuC8JJEAAvRsJYOA5PxJIgAB6NxbAwPM+JJAAAfTeSAADr8lfAgkQQO+NBTDwurwlkAAB9G4lgIHX5iuBBAigd2sBDLw+TwkkQAC9Owlg4D35SSABAujdWQAD78tLAgkQQO9eBDDw3nwkkAAB9O5NAAPvz0MCCRBA714FMDBj+yWQAAH07l0AA3O2WwIJEEDvQQQwMGt7JZAAAfQeTAAD87ZTgqEEsCLL5fIuZp3avJ5zarNtH3F3ncGsNQHsB2Rq9t06RVG8Pjo6+pzuJ8ntSmAHlhxAZwGsABbvPJ3bd7CPT9j2sliYsybAiFnGwxqegQS4zcXsZbFsTjJ3tGD9T+NhDY8ECNicZO5o6br+GzGQABOc724613WO11NA9gIYmDP0PwLv2D7i7jpjs2r2M3jwQfn2b93/xR6PhzU8trNRD4Cc0ddfAoyLBCBHApAjAciRAORIAHIkADkSgBwJQI4EIMetAJhjV8Asq6p6UJblQ0+xTtbNOsa6rXEpAGbYBSEf07neEjt2ksCrAFvz1eotpNP1CBIg/0iAFMywU8CXdK63FEVxia1OAXVgzmSxWNyfz+dnyAtnOUO3e9Yx1m2NWwFEMyQAORKAHAlAjgQgRwKQIwHIkQDkSAByJAA5EoActwJgzt8LQpxH3wXUgRmTqqrep3O9BR3fYatvA1Mwwz4dKzMdR9cDpGCGBGiIVwHsDiFNfh171ok3d9ApoA7MMQkez2azN3a/PU+xTmVZPrKOsW5r3AogmiEByJEA5EgAciQAORKAHAlAjgQgRwKQIwHIkQDkuBUAc6bIifNMY93WuBQAM6aLxeJDOtdbYsdOEngVwD4dKzMd5yTWboUEyD8SIAUzplVV/Urnegs6/sRWp4A6MGd6eHj4bH9//3w2m114inWybtYx1m2NWwFEMyQAORKAHAlAjgQgRwKQIwHIkQDkSAByJAA5EoActwJgju4Q0gCXAmCG3Sr+VTrXW9DxJbb68fAUzLBPx8pMx9ENIlIwQwI0xKsA9itj3F8Qgo52QYhOAXVgzmQ+nz/f3d29RL46y6V1s46xbmvcCiCaIQHIkQDkSAByJAA5EoAcCUCOBCBHApAjAciRAORIAHIkADkSgBwJQI4EIEcCkCMByJEA5EgAcrZSgLIsr+p+XZrSf2yt0/UfXQBl3EgA8kgA8kgA8rQTYGfnD9K0abxUqpkmAAAAAElFTkSuQmCC"
                    })
            }
        }

    }
</script>
